import React, { useRef, useState } from 'react';
import { scrollToHomeSection } from '../utils/scrollToHomeSection';
import TESTIMONIALS from '../data/testimonials';

const getInitials = (name) =>
  name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

const HeroTestimonialCard = ({ name, role, quote, image, variant }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const showPhoto = Boolean(image) && !imgFailed;

  return (
    <article className="hero-testimonial-card">
      <div
        className={`hero-testimonial-avatar hero-testimonial-avatar--${variant}`}
        aria-hidden={showPhoto ? 'true' : undefined}
      >
        {showPhoto ? (
          <img
            src={image}
            alt=""
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span>{getInitials(name)}</span>
        )}
      </div>
      <div className="hero-testimonial-copy">
        <p className="hero-testimonial-name">{name}</p>
        <p className="hero-testimonial-role">{role}</p>
        <p className="hero-testimonial-quote">{quote}</p>
      </div>
    </article>
  );
};

const HeroSection = () => {
  const primaryCtaRef = useRef(null);

  const handleScrollTo = (e, targetId) => {
    e.preventDefault();
    scrollToHomeSection(targetId);
  };

  const handlePrimaryClick = (e) => {
    handleScrollTo(e, 'contact');

    if (primaryCtaRef.current) {
      primaryCtaRef.current.style.transform = 'scale(0.97)';
      setTimeout(() => {
        if (primaryCtaRef.current) {
          primaryCtaRef.current.style.transform = 'scale(1)';
        }
      }, 150);
    }
  };

  return (
    <section className="hero-section" aria-labelledby="hero-heading">
      <div className="hero-layout">
        <div className="hero-copy">
          <h1 id="hero-heading" className="hero-headline">
            We Engineer Your Imagination into Reality
          </h1>
          <p className="hero-subtitle">AI &amp; Engineering Solutions</p>
        </div>

        <div className="hero-visual">
          <img
            src="/img/logo-black-hires.png"
            alt="monkstack"
            className="hero-logo"
          />
        </div>

        <div className="hero-actions">
          <a
            href="#contact"
            className="cta-button"
            ref={primaryCtaRef}
            onClick={handlePrimaryClick}
          >
            Get Started
          </a>
          <a
            href="#services"
            className="cta-button-outline"
            onClick={(e) => handleScrollTo(e, 'services')}
          >
            See in Action
          </a>
        </div>
      </div>

      <div className="hero-testimonials" aria-label="Customer testimonials">
        <div className="hero-testimonials-track">
          <div className="hero-testimonials-inner">
            {TESTIMONIALS.map((item, index) => (
              <HeroTestimonialCard
                key={`${item.name}-${index}`}
                name={item.name}
                role={item.role}
                quote={item.quote}
                image={item.image}
                variant={(index % 3) + 1}
              />
            ))}
            <div className="hero-testimonials-clone" aria-hidden="true">
              {TESTIMONIALS.map((item, index) => (
                <HeroTestimonialCard
                  key={`${item.name}-clone-${index}`}
                  name={item.name}
                  role={item.role}
                  quote={item.quote}
                  image={item.image}
                  variant={(index % 3) + 1}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
